import { render, staticRenderFns } from "./GenSkuOuterIdDialog.vue?vue&type=template&id=12e0bb40&scoped=true"
import script from "./GenSkuOuterIdDialog.vue?vue&type=script&lang=js"
export * from "./GenSkuOuterIdDialog.vue?vue&type=script&lang=js"
import style0 from "./GenSkuOuterIdDialog.vue?vue&type=style&index=0&id=12e0bb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e0bb40",
  null
  
)

export default component.exports